// src/components/About.js
import { useEffect, useState, useRef } from 'react';
import Home from '../Home/Home';
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from 'react-responsive-carousel';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import {useDispatch} from "react-redux";
import { addActiveEventData, addEventData } from '../../store/adminSlice';
import { useNavigate } from 'react-router-dom';
import Button from '@mui/material/Button';

const Landing = () => {

  const navigate = useNavigate();
  const [openLoader, setOpenLoader] = useState(true);
  const dispatch = useDispatch();
  const [message, setMessage] = useState("");
  const [activeInformation, setaAtiveInformation] = useState("");
  const hasFetched = useRef(false);

  useEffect(() => {
          if (hasFetched.current) return;
          hasFetched.current = true;
          fetch(process.env.REACT_APP_API_URL + "/event/get/latest/active")
              .then(response => response.json())
              .then(activeData => {
                  if(activeData && activeData.eventId) {
                    console.log("active event data", activeData)
                    dispatch(addActiveEventData(activeData));
                    checkActiveEventMessage(activeData);
                    setaAtiveInformation(activeData);
                      fetch(process.env.REACT_APP_API_URL + "/event/registration/get/summary/"+activeData.eventId)
                          .then(response => response.json())
                          .then(data => {
                            console.log("active data", data)
                              if (data && data.eventId) {
                                  dispatch(addEventData(data));
                                  setOpenLoader(false);
                              } else {
                                  setOpenLoader(false);
                              }
                          })
                          .catch(error => {
                              console.error("Error fetching event:", error);
                              setOpenLoader(false);
                          });
                  }
                  else {
                      setOpenLoader(false);
                    //   setActiveEvent(null);
                  }
  
              })
              .catch(error => {
                  console.error("Error fetching event:", error);
                  setOpenLoader(false);
              });
      }, []);

      function checkActiveEventMessage(activeData) {
        console.log(activeData.eventCode)
        let activeMeg = "";
        if(activeData.eventCode === 1 && activeData.registrationStatus === "open") {
          activeMeg = "Click here to register for Saraswati Pujo!"
        }
        else if (activeData.eventCode === 2) {
            let msg = "";
            if (activeData.registrationStatus === "open") {
                activeMeg = "Click here to register for Durga Pujo! " + msg;
            }
            else {
                activeMeg = msg;
            }
        }
        else if(activeData.eventCode === 3 && activeData.registrationStatus === "open") {
          activeMeg = "Click here to register for Bengali New Year!"
        }
        else if(activeData.eventCode === 4 && activeData.registrationStatus === "open") {
          activeMeg = "Click here to register for Summer Picnic!"
        }
        else {
          activeMeg = "Welcome To Udaan!!"
        }

        // if(activeData.earlyBirdStatus === "A") {
        //   activeMeg = activeMeg + " Early Bird Price On."
        // }
        console.log(activeMeg)
        setMessage(activeMeg)
      }

  return ( 
    <>
     <Backdrop 
        sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })} 
        open={openLoader}>
            <CircularProgress color="inherit" />
     </Backdrop>
  <Home>
    <a className="legend wordart rainbow landing_page_event_sentence" style={{fontFamily: 'fangsong'}}  onClick={() => navigate("/event/activeevent-detail")}>
      <span class="text"> {message} </span> { activeInformation.earlyBirdStatus === "A" && 
      <span className='blink'>Early Bird Price On! </span>}
    </a>
     <Carousel autoPlay infiniteLoop showThumbs={false} showStatus={false} showArrows={false} interval={3000}>
					 
					  <div>
                          <img src="./membership.jpg" />
                      </div>
					  <div>
                          <img src="./menu-26.jpg" />
                      </div>
                     <div>
                         <img src="./pujo-timing.jpg" />
                     </div>
					  <div>
                           <img src="./answesa1.jpg" />
                      </div>
					  <div>
                           <img src="./surojit.jpg" />
                      </div>
					  <div>
                          <img src="./44522671.jpg" />
                      </div>
                      <div>
                          <img src="./44549776.jpg" />
                      </div>
                      <div>
                           <img src="./482024832.jpg" />
                      </div>
                      <div>
                            <img src="./44641855.jpg" />
                      </div>
                      <div>
                            <img src="./72555652.jpg" />
                      </div>
                      <div>
                            <img src="./74155831.jpg" />
                      </div>
                      <div>
                            <img src="./74347875.jpg" />
                      </div>
                      <div>
                            <img src="./74531731.jpg" />
                      </div>
                      <div>
                            <img src="./75132186.jpg" />
                      </div>
                      <div>
                            <img src="./75402224.jpg" />
                      </div>
                      <div>
                            <img src="./495862280.jpg" />
                      </div>
                  </Carousel>

<div className='landingpage_register_btn'>
    {activeInformation.registrationStatus === "open" && (
                  <Button variant="contained" 
                        sx={{ 
                            marginRight: {
                                xs: "0px",  // mobile
                                sm: "20px", // tablet
                                md: "20px"  // desktop
                            },
                            marginLeft: {
                                xs: "10px",  // mobile
                                sm: "0px", // tablet
                                md: "0px"  // desktop
                            },
                            marginTop: {
                                xs: "10px",  // mobile
                                sm: "0px", // tablet
                                md: "0px"  // desktop
                            }
                        }} 
                        onClick={() => navigate("/event/activeevent-detail")}>Register Now
                  </Button>
        )}
                        </div>
  </Home>
  </>
  );
};

export default Landing;